(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["easter-egg"] && !Shopify.designMode) return;
  try {
    (() => {
    const egg = document.querySelector('[data-easter-egg]');
    if (!egg) return;

    let busy = false;

    // document.documentElement.clientWidth excludes the scrollbar, matching
    // the width every other centered element on the page is laid out against —
    // window.innerWidth (used by `left: 50%` on a fixed element) does not.
    const center = () => {
      egg.style.left = `${document.documentElement.clientWidth / 2}px`;
    };
    center();
    window.addEventListener('resize', center);

    const atPageBottom = () =>
      window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2;

    const trigger = () => {
      if (busy || !atPageBottom()) return;
      busy = true;
      egg.classList.add('is-visible');

      setTimeout(() => {
        egg.classList.remove('is-visible');
        setTimeout(() => {
          busy = false;
        }, 700);
      }, 2000);
    };

    window.addEventListener(
      'wheel',
      (event) => {
        if (event.deltaY > 0) trigger();
      },
      { passive: true }
    );

    let touchStartY = 0;
    window.addEventListener(
      'touchstart',
      (event) => {
        touchStartY = event.touches[0].clientY;
      },
      { passive: true }
    );
    window.addEventListener(
      'touchmove',
      (event) => {
        if (touchStartY - event.touches[0].clientY > 30) trigger();
      },
      { passive: true }
    );
  })();

  /* Clicking the character plays the ad in a chrome-less overlay (native
     <video>, no controls). It closes via the button, backdrop, Escape — or
     by itself once the video has played through. */
  (() => {
    const character = document.querySelector('[data-easter-egg-character]');
    const overlay = document.querySelector('[data-easter-video]');
    if (!character || !overlay) return;

    const egg = document.querySelector('[data-easter-egg]');
    const video = overlay.querySelector('[data-easter-video-player]');
    const closeButton = overlay.querySelector('[data-easter-video-close]');

    const close = () => {
      video.pause();
      video.currentTime = 0;
      overlay.hidden = true;
      document.removeEventListener('keydown', onKeydown);
    };

    const onKeydown = (event) => {
      if (event.key === 'Escape') close();
    };

    const open = () => {
      overlay.hidden = false;
      document.addEventListener('keydown', onKeydown);
      egg.classList.remove('is-visible');
      video.currentTime = 0;
      video.play();
    };

    video.addEventListener('ended', close);
    character.addEventListener('click', open);
    closeButton.addEventListener('click', close);
    overlay.addEventListener('click', (event) => {
      if (event.target === overlay) close();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (() => {
    // Flagship carousel: a slow crossfade through every product photo. It only
    // runs while the card is on screen, and pauses under the cursor so a
    // visitor reading the card never has the photo change under them.
    const SLIDE_MS = 4000;

    document.querySelectorAll('[data-card-slides]').forEach((track) => {
      const slides = [...track.querySelectorAll('.product-card__slide')];
      if (slides.length < 2) return;

      const card = track.closest('.product-card');
      const dots = [...card.querySelectorAll('.product-card__dot')];
      let index = 0;
      let timer = null;

      const show = (next) => {
        slides[index].classList.remove('is-current');
        if (dots[index]) dots[index].classList.remove('is-current');
        index = next;
        slides[index].classList.add('is-current');
        if (dots[index]) dots[index].classList.add('is-current');
      };

      track.classList.add('is-ready');
      show(0);

      const start = () => {
        if (timer) return;
        timer = setInterval(() => show((index + 1) % slides.length), SLIDE_MS);
      };
      const stop = () => {
        clearInterval(timer);
        timer = null;
      };

      // Reduced-motion visitors keep the first photo and no timer at all.
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      card.addEventListener('mouseenter', stop);
      card.addEventListener('mouseleave', start);

      new IntersectionObserver((entries) => {
        entries.forEach((entry) => (entry.isIntersecting ? start() : stop()));
      }).observe(card);
    });
  })();

  (() => {
    // Flagship smear clip: fetched and played only while the card is near the
    // viewport, so a visitor who never scrolls to it never downloads it.
    const smears = document.querySelectorAll('[data-card-smear]');
    if (smears.length === 0) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target.querySelector('video');
          if (!video) return;

          if (!entry.isIntersecting) {
            video.pause();
            return;
          }

          if (!video.src) video.src = video.dataset.smearSrc;
          video.play().then(
            () => entry.target.classList.add('is-playing'),
            () => {} // autoplay refused — the poster still stands in
          );
        });
      },
      { rootMargin: '200px' }
    );

    smears.forEach((smear) => observer.observe(smear));
  })();

  (() => {
    // Cards without an effect-image layer don't need to be tracked at all.
    const containers = document.querySelectorAll('[data-scroll-fade]:has([data-effect-image])');
    if (containers.length === 0) return;

    // Respect reduced-motion preference: leave effect layers at opacity 0
    // (original photo) and skip wiring up scroll listeners entirely.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    // Only cards within ~1 viewport height of the screen are tracked on
    // scroll — IntersectionObserver keeps this set cheap to maintain even
    // on pages with dozens of products, since getBoundingClientRect is only
    // read for cards that are plausibly near the viewport.
    const active = new Set();
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            active.add(entry.target);
          } else {
            active.delete(entry.target);
          }
        });
      },
      { rootMargin: '50% 0px 50% 0px' }
    );
    containers.forEach((container) => observer.observe(container));

    let ticking = false;

    const update = () => {
      ticking = false;
      const viewportCenter = window.innerHeight / 2;
      const maxDistance = window.innerHeight / 1.5;

      active.forEach((container) => {
        const effectImage = container.querySelector('[data-effect-image]');
        const rect = container.getBoundingClientRect();
        const elementCenter = rect.top + rect.height / 2;
        const distance = Math.abs(viewportCenter - elementCenter);
        const intensity = Math.min(Math.max(distance / maxDistance, 0), 1);

        // Non-linear curve: the effect stays subtle near the center and
        // ramps up faster as the card approaches the viewport edges.
        effectImage.style.opacity = Math.pow(intensity, 1.5);
      });
    };

    const onScrollOrResize = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize, { passive: true });
    update();
  })();

  (() => {
    // Desktop-only glitch flip-through of all product photos on hover.
    // Touch devices keep the static second photo below the card (see CSS).
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    /* Width belongs in this test, not just the pointer. A Mac keeps a fine
       pointer at every window size, so on a narrowed window the card went full
       width, the hover still fired, and the model photo — scaled to the
       waist-up crop — filled the screen. Same breakpoint as the CSS that
       styles the swap, and read live: the window crosses it without a reload. */
    const DESKTOP = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 750px)');

    // Reduced motion drops the animation, not the swap: the second photo still
    // has to appear under the cursor, it just arrives in one step.
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const GLITCH_MS = 520; // must match the CSS animation duration
    const PIXEL_DURATION_MS = 360; // full pixel dissolve, there and back
    const PIXEL_MAX_BLOCK = 30; // peak block size at the middle of the arc

    document.querySelectorAll('[data-flip-images]').forEach((card) => {
      let images;
      try {
        images = JSON.parse(card.dataset.flipImages);
      } catch (e) {
        return;
      }
      if (!Array.isArray(images) || images.length < 2) return;

      const effect = card.dataset.flipEffect || 'pixel';
      const media = card.querySelector('.product-card__media');
      const flip = card.querySelector('[data-flip-next]');
      const canvas = card.querySelector('[data-flip-canvas]');
      // Both stacked layers (plain + effect) swap together so the poster
      // effect keeps matching the visible photo.
      const layers = card.querySelectorAll('.product-card__image');
      if (!media || layers.length === 0) return;

      // Fade / zoom are pure CSS transitions on the cropped model photo —
      // no canvas, no timers, just a state class (plus the intent delay).
      if (effect === 'fade' || effect === 'zoom') {
        flip.src = images[1];
        let intent = null;
        const undo = () => {
          clearTimeout(intent);
          intent = null;
          media.classList.remove('is-swapped');
        };
        DESKTOP.addEventListener('change', (e) => {
          if (!e.matches) undo();
        });
        card.addEventListener('mouseenter', () => {
          if (!DESKTOP.matches) return;
          intent = setTimeout(() => {
            intent = null;
            media.classList.add('is-swapped');
          }, 90);
        });
        card.addEventListener('mouseleave', () => {
          if (intent) {
            clearTimeout(intent);
            intent = null;
            return;
          }
          media.classList.remove('is-swapped');
        });
        return;
      }

      let index = 0;
      let busy = false;
      let pending = null;
      let loaders = null;

      const swapLayers = (target) => {
        layers.forEach((layer) => {
          // Override srcset too, otherwise the browser keeps the old candidates.
          layer.srcset = images[target];
          layer.src = images[target];
        });
        index = target;
      };

      /* Which slice of a model photo stays inside the square card: CROP is how
         much of its height shows, FOCUS where that window starts (both 0–1,
         from the top). Defaults hold a full-body shot waist-up; per product
         they come from the card_model_crop / card_model_focus metafields. */
      const mediaStyle = getComputedStyle(media);
      const MODEL_CROP = parseFloat(mediaStyle.getPropertyValue('--model-crop')) || 0.5;
      const MODEL_FOCUS = parseFloat(mediaStyle.getPropertyValue('--model-focus')) || 0;

      // Every model photo is laid out to the card's width, so on its own each
      // one shows exactly `naturalWidth / naturalHeight` of the body. Scaling
      // by that ratio cancels it out and leaves the same waist-up crop for all
      // of them, however tall the original photo happens to be.
      const modelProbes = [];
      const fitModel = (target) => {
        media.classList.toggle('is-model', target !== 0);
        if (target === 0) return;
        if (!modelProbes[target]) {
          const probe = (loaders && loaders[target]) || new Image();
          if (!probe.src) probe.src = images[target];
          modelProbes[target] = probe;
        }
        const probe = modelProbes[target];
        const apply = () => {
          if (!probe.naturalWidth || !probe.naturalHeight) return;
          const ratio = probe.naturalWidth / probe.naturalHeight;
          media.style.setProperty('--model-fit', (ratio / MODEL_CROP).toFixed(4));
        };
        if (probe.complete) {
          apply();
        } else {
          probe.addEventListener('load', apply, { once: true });
        }
      };

      const finish = () => {
        busy = false;
        if (pending !== null) {
          const next = pending;
          pending = null;
          transitionTo(next);
        }
      };

      const preload = () => {
        if (loaders) return;
        loaders = images.map((src) => {
          const img = new Image();
          img.src = src;
          return img;
        });
      };

      // Warm the photos up front (after load, when the browser is idle), so
      // the very first hover doesn't stall on two large downloads.
      const warm = () => {
        if ('requestIdleCallback' in window) {
          requestIdleCallback(preload, { timeout: 3000 });
        } else {
          setTimeout(preload, 1500);
        }
      };
      if (document.readyState === 'complete') {
        warm();
      } else {
        window.addEventListener('load', warm, { once: true });
      }

      /* One blocky frame: draw the photo tiny, blow it back up unsmoothed. */
      const ctx = canvas ? canvas.getContext('2d') : null;
      const tmp = document.createElement('canvas');
      const tctx = tmp.getContext('2d');

      const drawPix = (image, px) => {
        const w = canvas.width;
        const h = canvas.height;
        const sw = Math.max(1, Math.round(w / px));
        const sh = Math.max(1, Math.round(h / px));
        tmp.width = sw;
        tmp.height = sh;
        tctx.clearRect(0, 0, sw, sh);
        // Match what the settled photo shows, otherwise the dissolve ends on a
        // different framing than it was drawing: the packshot is contained,
        // a model photo is cropped to MODEL_CROP of its height from the top.
        const isModel = loaders ? image !== loaders[0] : false;
        let dw;
        let dh;
        let dy;
        if (isModel) {
          dh = sh / MODEL_CROP;
          dw = dh * (image.naturalWidth / image.naturalHeight);
          dy = -MODEL_FOCUS * dh;
        } else {
          const r = Math.min(sw / image.naturalWidth, sh / image.naturalHeight);
          dw = image.naturalWidth * r;
          dh = image.naturalHeight * r;
          dy = (sh - dh) / 2;
        }
        tctx.drawImage(image, (sw - dw) / 2, dy, dw, dh);
        ctx.imageSmoothingEnabled = false;
        ctx.clearRect(0, 0, w, h);
        ctx.drawImage(tmp, 0, 0, w, h);
      };

      const pixelTo = (target) => {
        const from = loaders[index];
        const to = loaders[target];
        const run = () => {
          media.classList.add('is-pixelating');
          const start = performance.now();
          const frame = (now) => {
            // Block size rides a smooth sine arc (1 → max → 1); the photo
            // swaps at the peak, hidden inside the chunkiest frame.
            const t = Math.min(1, (now - start) / PIXEL_DURATION_MS);
            const px = 1 + Math.sin(t * Math.PI) * (PIXEL_MAX_BLOCK - 1);
            drawPix(t < 0.5 ? from : to, Math.max(1.001, px));
            if (t < 1) {
              requestAnimationFrame(frame);
            } else {
              swapLayers(target);
              // Only reveal the real image once the browser has decoded the
              // new photo — otherwise the old frame flashes for an instant.
              const reveal = () => {
                media.classList.remove('is-pixelating');
                finish();
              };
              layers[0].decode().then(reveal).catch(reveal);
            }
          };
          requestAnimationFrame(frame);
        };
        if (from.complete && to.complete && from.naturalWidth && to.naturalWidth) {
          run();
        } else {
          // First hover can land before the photos finish downloading.
          Promise.all([from.decode(), to.decode()]).then(run).catch(() => {
            swapLayers(target);
            finish();
          });
        }
      };

      const glitchTo = (target) => {
        flip.src = images[target];
        media.classList.add('is-glitching');
        setTimeout(() => {
          swapLayers(target);
          media.classList.remove('is-glitching');
          finish();
        }, GLITCH_MS);
      };

      const transitionTo = (target) => {
        if (busy) {
          pending = target;
          return;
        }
        if (target === index) return;
        busy = true;
        // Frame the incoming photo before the transition starts: the layers
        // are hidden behind the canvas meanwhile, and the glitch variant needs
        // the flip img already cropped when its animation begins.
        fitModel(target);
        if (reducedMotion) {
          swapLayers(target);
          finish();
        } else if (effect === 'pixel' && canvas && ctx) {
          pixelTo(target);
        } else {
          glitchTo(target);
        }
      };

      // One-shot: a single transition to the second photo on hover, then
      // static; leaving transitions back to the first photo. A short intent
      // delay keeps a quick pass-over from firing the effect on every card.
      let intent = null;

      DESKTOP.addEventListener('change', (e) => {
        if (e.matches) return;
        clearTimeout(intent);
        intent = null;
        transitionTo(0);
      });

      card.addEventListener('mouseenter', () => {
        if (!DESKTOP.matches) return;
        preload();
        intent = setTimeout(() => {
          intent = null;
          transitionTo(1);
        }, 90);
      });

      card.addEventListener('mouseleave', () => {
        if (intent) {
          clearTimeout(intent);
          intent = null;
          return; // effect never started — nothing to undo
        }
        transitionTo(0);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
